/* GLINT — acces aux medias natifs, sans changer leur ordre ni leur rendu. */
(() => {
  const init = () => {
    document.querySelectorAll('.product-information__grid').forEach((grid) => {
      grid.classList.add('glint-pdp-da2');
      const gallery = grid.querySelector('media-gallery');
      const container = grid.querySelector('.product-information__media');
      if (!gallery || !container || container.querySelector('.glint-pdp-media-nav')) return;
      const slides = Array.from(gallery.querySelector('slideshow-component')?.querySelectorAll('slideshow-slide') || []);
      const media = slides.length ? slides : Array.from(gallery.querySelectorAll('.media-gallery__grid > li'));
      if (!media.length) return;
      const nav = document.createElement('nav');
      nav.className = 'glint-pdp-media-nav';
      nav.setAttribute('aria-label', window.GlintI18n.t('product.media_views'));
      const buttons = [];
      const setActive = (index) => {
        buttons.forEach((button, position) => {
          button.setAttribute('aria-current', String(position === index));
        });
      };
      let imageNumber = 0;
      media.forEach((item, index) => {
        const isModel = item.classList.contains('product-media-container--model');
        const isVideo = item.classList.contains('product-media-container--video') || item.classList.contains('product-media-container--external_video');
        if (!isModel && !isVideo) imageNumber += 1;
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = isModel ? window.GlintI18n.t('product.media_turn') : isVideo ? window.GlintI18n.t('product.media_motion') : imageNumber === 1 ? window.GlintI18n.t('product.media_piece') : imageNumber === 2 ? window.GlintI18n.t('product.media_detail') : window.GlintI18n.t('product.media_view_number', { count: imageNumber });
        button.addEventListener('click', (event) => {
          const currentGallery = grid.querySelector('media-gallery');
          if (!currentGallery) return;
          const desktopGrid = currentGallery.querySelector('.media-gallery__grid');
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          if (desktopGrid && getComputedStyle(desktopGrid).display !== 'none') {
            desktopGrid.children[index]?.scrollIntoView({ block: 'start', behavior });
            setActive(index);
          } else {
            const slideshow = currentGallery.slideshow || currentGallery.querySelector('slideshow-component');
            /* Meme glissement que les fleches et vignettes. La galerie garde
               les medias montes ; slideshow respecte le mouvement reduit. */
            slideshow?.select?.(index, event);
          }
        });
        buttons.push(button);
        nav.appendChild(button);
      });
      gallery.parentElement.insertBefore(nav, gallery);
      const slideshow = gallery.slideshow || gallery.querySelector('slideshow-component');
      setActive(slideshow?.current ?? 0);
      /* Evenement public Horizon : couvre les clics, les vignettes et le swipe.
         Le conteneur survit au remplacement de la galerie apres une variante. */
      container.addEventListener('slideshow:select', (event) => {
        const currentGallery = grid.querySelector('media-gallery');
        const currentSlideshow = currentGallery?.slideshow || currentGallery?.querySelector('slideshow-component');
        if (event.target !== currentSlideshow) return;
        const index = event.detail?.index;
        if (Number.isInteger(index) && index >= 0 && index < buttons.length) setActive(index);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* GLINT — raccourci mobile vers le selecteur natif, sans action panier. */
(() => {
  const controllers = new WeakMap();
  function initSizeAccess() {
    document.querySelectorAll('.product-information__grid').forEach(grid => {
      if (controllers.has(grid)) return;
      const bar = grid.querySelector('[data-glint-size-access]');
      const button = bar?.querySelector('[data-glint-choose-size]');
      const section = grid.closest('.shopify-section');
      if (!bar || !button || !section) return;
      const price = document.createElement('span');
      price.className = 'glint-pdp-size-access__price';
      price.setAttribute('data-glint-size-price', '');
      price.hidden = true;
      bar.insertBefore(price, button);
      const mobile = matchMedia('(max-width: 749px)');
      const abort = new AbortController();
      const { signal } = abort;
      let frame = 0;
      let disposed = false;
      let productSelectEvent;
      let observedPicker;
      let observedBuy;
      let navigationTimer;
      let navigating = false;
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(schedule) : null;
      document.body.appendChild(bar);
      controllers.set(grid, dispose);

      function targets() {
        const picker = grid.querySelector('.product-details variant-picker[ref="mainVariantPicker"]');
        const buy = grid.querySelector('.product-details .buy-buttons-block');
        const choices = Array.from(picker?.querySelectorAll('input[type="radio"], select') || []).filter(control =>
          !control.disabled && control.getAttribute('aria-disabled') !== 'true' && control.dataset.optionAvailable !== 'false'
        );
        const named = choices.filter(control => /^(size|taille)$/i.test(control.dataset.optionName || ''));
        const candidates = named.length ? named : choices;
        const control = candidates.find(item => item.checked) || candidates[0];
        return { picker, buy, control, group: control?.closest('fieldset, .variant-option') || picker };
      }
      function blocked() {
        return grid.hasAttribute('data-glint-bundle-active') ||
          Boolean(document.querySelector('dialog[open], header-drawer details[open]')) ||
          Boolean(customElements.get('shopify-chat') && document.querySelector('shopify-chat')) ||
          Boolean(document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]), textarea, [contenteditable="true"]'));
      }
      function refreshObservers(picker, buy) {
        if (!observer || observedPicker === picker && observedBuy === buy) return;
        observer.disconnect();
        if (picker) observer.observe(picker);
        if (buy) observer.observe(buy);
        observedPicker = picker;
        observedBuy = buy;
      }
      function syncPrice() {
        /* Le vrai prix PDP contient deja le format monetaire du marche.
           Ne pas recopier le prix barre, l'unite ou les libelles masques. */
        const rendered = grid.querySelector('.product-details product-price [ref="priceContainer"] .price');
        const copy = rendered?.cloneNode(true);
        copy?.querySelectorAll('.visually-hidden').forEach(label => label.remove());
        const value = copy?.textContent.trim() || '';
        if (price.textContent !== value) price.textContent = value;
        price.hidden = !value;
      }
      function sync() {
        if (disposed) return;
        if (!grid.isConnected) { dispose(); initSizeAccess(); return; }
        const { picker, buy, control, group } = targets();
        syncPrice();
        refreshObservers(picker, buy);
        const viewportHeight = window.visualViewport?.height || innerHeight;
        if (group && group.getBoundingClientRect().top < viewportHeight) {
          navigating = false;
          clearTimeout(navigationTimer);
        }
        const canShow = mobile.matches && !navigating && !document.hidden && !blocked() && control && group && buy &&
          group.getBoundingClientRect().top >= viewportHeight && buy.getBoundingClientRect().top >= viewportHeight &&
          !section.querySelector('sticky-add-to-cart [data-stuck="true"]');
        bar.hidden = !canShow;
      }
      function schedule() {
        if (disposed || frame) return;
        frame = requestAnimationFrame(() => { frame = 0; sync(); });
      }
      function chooseSize() {
        if (!mobile.matches || blocked()) return;
        const { control, group } = targets();
        if (!control || !group || !group.isConnected) return;
        const wrapper = document.querySelector('.page-wrapper');
        const scrollingWrapper = wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1 &&
          /(auto|scroll)/.test(getComputedStyle(wrapper).overflowY);
        const headerBottom = document.querySelector('header')?.getBoundingClientRect().bottom || 0;
        const offset = Math.max(0, headerBottom) + 12;
        const rect = group.getBoundingClientRect();
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        navigating = true;
        clearTimeout(navigationTimer);
        navigationTimer = setTimeout(() => { navigating = false; schedule(); }, 1200);
        bar.hidden = true;
        control.focus({ preventScroll: true });
        if (scrollingWrapper) {
          const wrapperTop = wrapper.getBoundingClientRect().top;
          wrapper.scrollTo({ top: Math.max(0, wrapper.scrollTop + rect.top - Math.max(offset, wrapperTop)), behavior });
        } else {
          window.scrollTo({ top: Math.max(0, window.scrollY + rect.top - offset), behavior });
        }
      }
      function productSelect(event) {
        if (!(event.target instanceof Element) || !grid.querySelector('.product-details')?.contains(event.target)) return;
        event.promise?.then(schedule).catch(() => {});
      }
      function interaction(event) {
        if (event.target.closest?.('[data-offer-pack]')) {
          bar.hidden = true;
          requestAnimationFrame(() => setTimeout(schedule, 0));
        } else schedule();
      }
      function dispose() {
        if (disposed) return;
        disposed = true;
        abort.abort();
        observer?.disconnect();
        if (frame) cancelAnimationFrame(frame);
        clearTimeout(navigationTimer);
        if (productSelectEvent) section.removeEventListener(productSelectEvent, productSelect);
        bar.remove();
        controllers.delete(grid);
      }
      button.addEventListener('click', chooseSize, { signal });
      document.addEventListener('scroll', schedule, { passive: true, capture: true, signal });
      document.addEventListener('click', interaction, { capture: true, signal });
      document.addEventListener('change', schedule, { signal });
      document.addEventListener('toggle', schedule, { capture: true, signal });
      document.addEventListener('close', schedule, { capture: true, signal });
      document.addEventListener('dialog:open', schedule, { capture: true, signal });
      document.addEventListener('dialog:close', schedule, { capture: true, signal });
      document.addEventListener('focusin', schedule, { signal });
      document.addEventListener('focusout', schedule, { signal });
      document.addEventListener('visibilitychange', schedule, { signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      window.visualViewport?.addEventListener('resize', schedule, { passive: true, signal });
      mobile.addEventListener('change', schedule, { signal });
      customElements.whenDefined('shopify-chat').then(schedule);
      import('@shopify/events').then(({ StandardEvents }) => {
        if (disposed) return;
        productSelectEvent = StandardEvents.productSelect;
        section.addEventListener(productSelectEvent, productSelect);
      }).catch(() => {});
      section.addEventListener('shopify:section:unload', dispose, { once: true, signal });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSizeAccess, { once: true });
  else initSizeAccess();
  document.addEventListener('shopify:section:load', initSizeAccess);
})();

/* Lecture PDP : seules les vidéos Shopify visibles sont montées automatiquement. */
(() => {
  const controllers = new WeakSet();
  function initVideos() {
    document.querySelectorAll('.product-information__media').forEach(container => {
      if (controllers.has(container)) return;
      controllers.add(container);
      const section = container.closest('.shopify-section');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const connection = navigator.connection;
      const states = new Map();
      let disposed = false;
      let selectedSlide = null;
      let frame = 0;
      let productSelectEvent;
      const allowed = () => !reduced.matches && !connection?.saveData;
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        if (disposed) return;
        entries.forEach(entry => {
          const state = states.get(entry.target);
          if (state) state.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
        });
        sync();
      }, { threshold: [0, 0.15, 0.5, 1] }) : null;

      function active(state) {
        if (!observer) {
          const rect = state.host.getBoundingClientRect();
          const width = Math.max(0, Math.min(rect.right, innerWidth) - Math.max(rect.left, 0));
          const height = Math.max(0, Math.min(rect.bottom, innerHeight) - Math.max(rect.top, 0));
          state.ratio = rect.width && rect.height ? width * height / (rect.width * rect.height) : 0;
        }
        if (!state.host.isConnected || document.hidden || state.ratio < 0.15) return false;
        const gallery = container.querySelector('media-gallery');
        if (!gallery?.contains(state.host)) return false;
        const grid = state.host.closest('.media-gallery__grid');
        if (grid) return getComputedStyle(grid).display !== 'none';
        const slide = state.host.closest('slideshow-slide');
        const slideshow = gallery.slideshow || gallery.querySelector('slideshow-component');
        if (!slide || !slideshow || getComputedStyle(slideshow).display === 'none') return false;
        const current = selectedSlide?.isConnected && slideshow.contains(selectedSlide)
          ? selectedSlide : Array.from(slideshow.querySelectorAll('slideshow-slide'))[slideshow.current ?? 0];
        return slide === current;
      }
      function hint(state, playing) {
        state.host.isPlaying = playing;
        state.host.updatePlayPauseHint?.(playing);
      }
      function pause(state) {
        state.request++;
        if (state.video && !state.video.paused) {
          state.automaticPauses++;
          state.video.pause();
        }
        if (state.video) hint(state, false);
      }
      function bindVideo(state) {
        const video = state.host.querySelector('video');
        if (!video || video === state.video) return video;
        state.video = video;
        video.muted = true;
        video.preload = 'none';
        video.removeAttribute('autoplay');
        const play = () => {
          if (disposed) return;
          if (!active(state)) { pause(state); return; }
          state.wants = true;
          state.suspended = false;
          hint(state, true);
        };
        const paused = () => {
          if (disposed) return;
          if (state.automaticPauses) state.automaticPauses--;
          else if (active(state)) state.wants = false;
          hint(state, false);
        };
        const ended = () => { if (!video.loop) state.wants = false; hint(state, false); };
        const error = () => { state.wants = false; hint(state, false); };
        state.events = { play, pause: paused, ended, error };
        Object.entries(state.events).forEach(([type, fn]) => video.addEventListener(type, fn));
        return video;
      }
      function sync() {
        if (disposed) return;
        refresh();
        const candidates = [...states.values()].filter(state => active(state) && state.wants && !state.suspended);
        const chosen = candidates.sort((a, b) => b.ratio - a.ratio)[0];
        states.forEach(state => { if (state !== chosen) pause(state); });
        if (!chosen) return;
        if (!chosen.host.querySelector('video')) {
          if (typeof chosen.host.loadContent !== 'function') return;
          chosen.host.loadContent(false);
        }
        const video = bindVideo(chosen);
        if (!video || !video.paused || video.ended) return;
        const request = ++chosen.request;
        video.play().catch(error => {
          if (disposed || request !== chosen.request || error.name === 'AbortError') return;
          chosen.wants = false;
          hint(chosen, false);
        });
      }
      function remove(state) {
        pause(state);
        observer?.unobserve(state.host);
        if (state.video && state.events) Object.entries(state.events).forEach(([type, fn]) => state.video.removeEventListener(type, fn));
        states.delete(state.host);
      }
      function refresh() {
        states.forEach(state => { if (!container.contains(state.host)) remove(state); });
        container.querySelectorAll('media-gallery deferred-media').forEach(host => {
          if (host.closest('dialog') || states.has(host)) return;
          const templateVideo = host.querySelector('template')?.content.querySelector('video');
          if (!templateVideo && !host.querySelector('video')) return;
          /* Préparer le clone avant loadContent : aucun départ sonore ou
             autoplay concurrent déclenché par le composant natif. */
          if (templateVideo) {
            templateVideo.muted = true;
            templateVideo.defaultMuted = true;
            templateVideo.setAttribute('muted', '');
            templateVideo.removeAttribute('autoplay');
            templateVideo.preload = 'none';
          }
          const state = { host, video: null, ratio: 0, wants: allowed(), suspended: false, automaticPauses: 0, request: 0 };
          states.set(host, state);
          bindVideo(state);
          observer?.observe(host);
        });
      }
      function schedule() {
        if (disposed || frame) return;
        frame = requestAnimationFrame(() => { frame = 0; sync(); });
      }
      function select(event) {
        const gallery = container.querySelector('media-gallery');
        const slideshow = gallery?.slideshow || gallery?.querySelector('slideshow-component');
        if (event.target !== slideshow) return;
        selectedSlide = event.detail?.slide || null;
        states.forEach(state => { state.suspended = false; });
        sync();
        schedule();
      }
      function click(event) {
        const host = event.target.closest?.('deferred-media');
        const state = states.get(host);
        if (state && !host.querySelector('video')) {
          state.wants = true;
          state.suspended = false;
          /* Après le gestionnaire public showDeferredMedia du bouton. */
          queueMicrotask(() => { if (!disposed) { bindVideo(state); sync(); } });
        } else if (event.target.closest?.('.glint-pdp-media-nav')) {
          states.forEach(item => { item.suspended = false; });
          schedule();
        }
      }
      function mediaStarted(event) {
        const resource = event.detail?.resource;
        states.forEach(state => {
          if (state.host !== resource) { pause(state); state.suspended = !states.has(resource); }
        });
      }
      function preference() {
        if (!allowed()) states.forEach(state => { state.wants = false; });
        sync();
      }
      function productSelect(event) {
        event.promise?.then(() => { selectedSlide = null; schedule(); }).catch(() => {});
      }
      refresh();
      container.addEventListener('slideshow:select', select);
      container.addEventListener('click', click, true);
      document.addEventListener('media:started-playing', mediaStarted, true);
      document.addEventListener('visibilitychange', sync);
      window.addEventListener('resize', schedule);
      if (!observer) window.addEventListener('scroll', schedule, { passive: true, capture: true });
      reduced.addEventListener('change', preference);
      connection?.addEventListener?.('change', preference);
      customElements.whenDefined('deferred-media').then(() => { if (!disposed) sync(); });
      import('@shopify/events').then(({ StandardEvents }) => {
        if (disposed) return;
        productSelectEvent = StandardEvents.productSelect;
        section?.addEventListener(productSelectEvent, productSelect);
      }).catch(() => {});
      section?.addEventListener('shopify:section:unload', () => {
        disposed = true;
        controllers.delete(container);
        if (frame) cancelAnimationFrame(frame);
        states.forEach(remove);
        observer?.disconnect();
        container.removeEventListener('slideshow:select', select);
        container.removeEventListener('click', click, true);
        document.removeEventListener('media:started-playing', mediaStarted, true);
        document.removeEventListener('visibilitychange', sync);
        window.removeEventListener('resize', schedule);
        window.removeEventListener('scroll', schedule, true);
        reduced.removeEventListener('change', preference);
        connection?.removeEventListener?.('change', preference);
        if (productSelectEvent) section.removeEventListener(productSelectEvent, productSelect);
      }, { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initVideos, { once: true });
  else initVideos();
  document.addEventListener('shopify:section:load', initVideos);
})();

/* PDP 3D : garder la vraie image jusqu'au premier rendu du modele courant.
   Aucun reglage du viewer : le moteur GLINT reste seul responsable de la 3D. */
(() => {
  const controllers = new WeakSet();
  function initModelCovers() {
    document.querySelectorAll('.product-information__media').forEach(container => {
      if (controllers.has(container)) return;
      controllers.add(container);
      const section = container.closest('.shopify-section');
      const states = new Map();
      let disposed = false;
      let refreshFrame = 0;
      let productSelectEvent;
      const source = viewer => viewer?.getAttribute('src') || '';
      const sameSource = (first, second) => {
        try { return new URL(first, document.baseURI).href === new URL(second, document.baseURI).href; }
        catch { return first === second; }
      };
      function cancel(state) {
        state.frames.forEach(cancelAnimationFrame);
        state.frames = [];
      }
      function pending(state) {
        cancel(state);
        state.host.removeAttribute('data-glint-model-ready');
      }
      function current(state) {
        return !disposed && container.isConnected && container.contains(state.host) &&
          state.viewer?.isConnected && state.host.querySelector('model-viewer') === state.viewer &&
          source(state.viewer) === state.source;
      }
      function paint(state) {
        if (!current(state) || !state.loadSeen || !state.viewer.loaded || !state.viewer.modelIsVisible) return;
        if (state.host.hasAttribute('data-glint-model-ready') || state.frames.length) return;
        const viewer = state.viewer;
        const url = state.source;
        const ready = () => current(state) && state.viewer === viewer && state.source === url &&
          state.loadSeen && viewer.loaded && viewer.modelIsVisible;
        state.frames.push(requestAnimationFrame(() => {
          if (!ready()) { cancel(state); return; }
          state.frames.push(requestAnimationFrame(() => {
            if (ready()) state.host.setAttribute('data-glint-model-ready', 'true');
            state.frames = [];
          }));
        }));
      }
      function bind(state) {
        const viewer = state.host.querySelector('model-viewer');
        const url = source(viewer);
        if (state.viewer !== viewer || state.source !== url) {
          const changedSource = state.viewer === viewer;
          pending(state);
          state.detach?.();
          state.viewer = viewer;
          state.source = url;
          /* Un nouveau src ne peut pas reutiliser le loaded du modele precedent. */
          state.loadSeen = !changedSource && Boolean(viewer?.loaded);
          state.detach = null;
          if (viewer) {
            const loaded = event => {
              bind(state);
              if (!current(state) || state.viewer !== viewer ||
                event.detail?.url && !sameSource(event.detail.url, state.source)) return;
              state.loadSeen = true;
              paint(state);
            };
            const visible = () => { bind(state); paint(state); };
            const error = () => {
              if (state.viewer !== viewer) return;
              state.loadSeen = false;
              pending(state);
            };
            viewer.addEventListener('load', loaded);
            viewer.addEventListener('model-visibility', visible);
            viewer.addEventListener('error', error);
            state.detach = () => {
              viewer.removeEventListener('load', loaded);
              viewer.removeEventListener('model-visibility', visible);
              viewer.removeEventListener('error', error);
            };
          }
        }
        paint(state);
      }
      function remove(state) {
        state.observer.disconnect();
        state.detach?.();
        pending(state);
        state.host.removeAttribute('data-glint-model-cover');
        states.delete(state.host);
      }
      function refresh() {
        if (disposed) return;
        states.forEach(state => { if (!container.contains(state.host)) remove(state); });
        container.querySelectorAll('media-gallery product-model').forEach(host => {
          if (host.closest('dialog') || states.has(host)) return;
          const state = { host, viewer: null, source: '', loadSeen: false, frames: [], detach: null };
          host.setAttribute('data-glint-model-cover', '');
          /* Observation du seul host natif : montage, clone GLINT et src.
             Ni body, ni document, ni mutation de l'arbre du viewer. */
          state.observer = new MutationObserver(() => bind(state));
          state.observer.observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
          states.set(host, state);
          bind(state);
        });
      }
      function productSelect(event) {
        event.promise?.then(() => {
          if (disposed) return;
          if (refreshFrame) cancelAnimationFrame(refreshFrame);
          refreshFrame = requestAnimationFrame(() => { refreshFrame = 0; refresh(); });
        }).catch(() => {});
      }
      refresh();
      customElements.whenDefined('model-viewer').then(() => { if (!disposed) states.forEach(bind); });
      import('@shopify/events').then(({ StandardEvents }) => {
        if (disposed) return;
        productSelectEvent = StandardEvents.productSelect;
        section?.addEventListener(productSelectEvent, productSelect);
      }).catch(() => {});
      section?.addEventListener('shopify:section:unload', () => {
        disposed = true;
        if (refreshFrame) cancelAnimationFrame(refreshFrame);
        states.forEach(remove);
        if (productSelectEvent) section.removeEventListener(productSelectEvent, productSelect);
        controllers.delete(container);
      }, { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initModelCovers, { once: true });
  else initModelCovers();
  document.addEventListener('shopify:section:load', initModelCovers);
})();
